import type { Video_Provider } from "@/graphql/generated-types";
import type { IFileState, IMedia } from "@/interfaces";
import type { MediaType } from "@/types";

const toMedia = (
  item: IFileState,
  type: MediaType,
  provider?: Video_Provider,
): IMedia => {
  const url = item.url || item.base64 || "";

  return {
    type,
    url,
    provider,
  };
};

const toYoutubeVideo = (link: string) => {
  const regex = /(?:\?v=|\/embed\/|\.be\/|\/shorts\/)([A-Za-z0-9_-]{11})/;

  const match = link.match(regex);

  if (match?.[1]) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }

  return link;
};

const toVimeoVideo = (url: string) => {
  const match = url.match(/^https?:\/\/(www\.)?vimeo\.com\/(\d+)$/);

  return match ? `https://player.vimeo.com/video/${match[2]}` : url;
};

const toVideoLink = (link: string) => {
  if (link.includes("youtube.com")) {
    return toYoutubeVideo(link);
  }

  if (link.includes("vimeo.com")) {
    return toVimeoVideo(link);
  }

  return link;
};

export default {
  toMedia,
  toVideoLink,
  toYoutubeVideo,
  toVimeoVideo,
};
